// The splash screen itself lives in public/index.html so it is visible
// before the bundle has loaded; this only takes care of dismissing it.
const minimumVisibleDuration = 2100
const leaveDuration = 1000

export function dismissSplash() {
  const splash = document.getElementById('splash')

  if (!splash) {
    return
  }

  if (!document.documentElement.classList.contains('splash-on')) {
    splash.remove()

    return
  }

  setTimeout(() => {
    splash.classList.add('splash-leave')

    setTimeout(() => {
      splash.remove()
      document.documentElement.classList.remove('splash-on')
    }, leaveDuration)
  }, Math.max(0, minimumVisibleDuration - performance.now()))
}
